export default function playbuzzEmbedScript(data) {
    return (`
        <script type="text/javascript">
            (function() {
                const script = document.createElement('script');
                script.async = 1;
                script.src = '//cdn.playbuzz.com/widget/feed.js';
                document.body.appendChild(script);
            }());
        </script>
        ${data}
    `);
}



// WEBPACK FOOTER //
// src/components/editor/playbuzzEmbed.js